import React, { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import { endPoints } from "../../../constant/Environment";
import Loader from "../../../components/Loader";
import { getAllData } from "../../../Utility/API";
import { tokens } from "../../../theme";
import { mono, pill, statusKind, th, td } from "../../../components/tableKit";

const STEPS = ["Signup", "Email verify", "KYC", "Coin purchase"];

// Horizontal referral-progress stepper in the template's dark style.
const StatusStepper = ({ data }) => {
  const validStatus = [
    data.isSingup == 1,
    data.verification == 1,
    data.validation == 1,
    data.packageCount > 0,
  ];

  return (
    <Box sx={{ display: "flex", alignItems: "flex-start" }}>
      {STEPS.map((step, index) => {
        const done = validStatus[index];
        const connected = index < STEPS.length - 1 && validStatus[index] && validStatus[index + 1];
        return (
          <Box key={step} sx={{ display: "flex", alignItems: "flex-start" }}>
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", width: 62 }}>
              <Box
                sx={{
                  width: 18,
                  height: 18,
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  bgcolor: done ? "rgba(35,214,160,0.18)" : "transparent",
                  border: `1.5px solid ${done ? tokens.secondary : tokens.border2}`,
                  color: tokens.secondary,
                  flexShrink: 0,
                }}
              >
                {done && <CheckRoundedIcon sx={{ fontSize: 12 }} />}
              </Box>
              <Typography sx={{ fontSize: 9.5, color: done ? tokens.text : tokens.textDim2, mt: 0.5, textAlign: "center", lineHeight: 1.2 }}>
                {step}
              </Typography>
            </Box>
            {index < STEPS.length - 1 && (
              <Box sx={{ height: 1.5, width: 18, mt: "9px", mx: -2, bgcolor: connected ? tokens.secondary : tokens.border, flexShrink: 0 }} />
            )}
          </Box>
        );
      })}
    </Box>
  );
};

const ReferFriendHistory = ({ userId }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [referList, setReferList] = useState([]);

  const fetchReferData = () => {
    let url = `${endPoints.api.REFER_USERS}/${userId}`;
    setIsLoading(true);
    getAllData(url)
      .then((response) => {
        const { status, data } = response;
        setIsLoading(false);
        if (status === "success") {
          setReferList(data);
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  };

  useEffect(() => {
    fetchReferData();
  }, []);

  return (
    <Box>
      {isLoading && <Loader spinner={true} visible={isLoading} />}

      <Box sx={{ mb: 2 }}>
        <Typography variant="h6">Refer Friend List</Typography>
        <Typography variant="caption" color="text.secondary">
          Referred players & their signup progress
        </Typography>
      </Box>

      <Box sx={{ overflowX: "auto" }}>
        <Box component="table" sx={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th style={th}>Player</th>
              <th style={th}>Bonus Amount</th>
              <th style={th}>Progress</th>
              <th style={th}>Bonus Status</th>
            </tr>
          </thead>
          <tbody>
            {(!referList || referList.length === 0) && !isLoading && (
              <tr>
                <td colSpan={4} style={{ ...td, textAlign: "center", color: tokens.textDim }}>
                  No referred friends yet
                </td>
              </tr>
            )}
            {referList?.map((row, i) => (
              <tr key={row.userId ?? i}>
                <td style={td}>
                  <div style={{ fontWeight: 600 }}>{row.name}</div>
                  <div style={{ fontFamily: mono, fontSize: 10.5, color: tokens.textDim2 }}>
                    #{row.userId} · {row.email}
                  </div>
                </td>
                <td style={{ ...td, fontFamily: mono, fontWeight: 700 }}>{row.referamount}</td>
                <td style={td}>
                  <StatusStepper data={row} />
                </td>
                <td style={td}>{row.referStatus ? pill(row.referStatus, statusKind(row.referStatus)) : "—"}</td>
              </tr>
            ))}
          </tbody>
        </Box>
      </Box>
    </Box>
  );
};

export default ReferFriendHistory;
